import styles from './Shell.module.css';

export const splitWordmark = (name: string): readonly [string, string] => {
  const suffixStart = name.lastIndexOf('.');
  return suffixStart <= 0 ? [name, ''] : [name.slice(0, suffixStart), name.slice(suffixStart)];
};

export type WordmarkSurface = 'brand' | 'plain';

const SUFFIX_CLASSES: Readonly<Record<WordmarkSurface, string | undefined>> = {
  brand: styles['brandSuffix'],
  plain: styles['brandSuffixPlain'],
};

export const Wordmark = ({ name, surface }: { name: string; surface: WordmarkSurface }) => {
  const [base, suffix] = splitWordmark(name);
  return (
    <span className={styles['brandName']} title={name}>
      {base}
      {suffix === '' ? null : <span className={SUFFIX_CLASSES[surface]}>{suffix}</span>}
    </span>
  );
};
